
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cI6uD", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherComponentWrapper", () => $8af4b0fc643359aa$export$4f7b43ba65213bd);

var $gwFzn = parcelRequire("gwFzn");

var $luv00 = parcelRequire("luv00");

var $5Zmpm = parcelRequire("5Zmpm");
const $8af4b0fc643359aa$export$4f7b43ba65213bd = (props)=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-vc": "app-navigation-app-switcher",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5Zmpm.AppSwitcherComponent), props));
};

});
parcelRegister("5Zmpm", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherComponent", () => $87f5aa0f5bf06dd6$export$6325b69f8dd8cc5d);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $Asv1P = parcelRequire("Asv1P");

var $lGgRw = parcelRequire("lGgRw");

var $iZfSS = parcelRequire("iZfSS");

var $5izcQ = parcelRequire("5izcQ");

var $f1YjX = parcelRequire("f1YjX");

var $9wGTI = parcelRequire("9wGTI");

var $dPJCf = parcelRequire("dPJCf");

var $dPJCf = parcelRequire("dPJCf");

var $7aRa9 = parcelRequire("7aRa9");

var $jmjWc = parcelRequire("jmjWc");

var $bQm3c = parcelRequire("bQm3c");

var $dEBDF = parcelRequire("dEBDF");

var $52id1 = parcelRequire("52id1");

var $akh1w = parcelRequire("akh1w");
const $87f5aa0f5bf06dd6$var$i18n = (0, $2nPZH.defineMessages)({
    appSwitcherTooltip: {
        id: "app-navigation.app-switcher.tooltip",
        defaultMessage: "Switch to..."
    },
    appSwitcherLabel: {
        id: "app-navigation.app-switcher.label",
        defaultMessage: "Switch to other Atlassian services"
    }
});
const $87f5aa0f5bf06dd6$var$CONFLUENCE_PRODUCT = 'confluence';

const $87f5aa0f5bf06dd6$var$SwitcherContentLoadable = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "o1PWq",
    name: "SwitcherContentLoadable",
    loader: async ()=>(await (parcelRequire("h2zMU"))).SwitcherContent
});

const $87f5aa0f5bf06dd6$export$582f757cbaeaf9c0 = ({ flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { isLicensed: isLicensed, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { isJswXflowUserQSEligible: isJswXflowUserQSEligible } = (0, $52id1.useQuickstartEligible)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    (0, $gwFzn.useEffect)(()=>{
        (async ()=>{
            const { checkJpdCrossJoinNudgeEligibility: checkJpdCrossJoinNudgeEligibility, showJpdCrossJoinNudge: showJpdCrossJoinNudge, triggerJiraCrossJoinNudge: triggerJiraCrossJoinNudge } = await (parcelRequire("rIJcv"));
            const isJpdCrossJoinNudgesEligible = await checkJpdCrossJoinNudgeEligibility({
                cloudId: cloudId,
                userId: userId,
                createAnalyticsEvent: createAnalyticsEvent
            });
            isJpdCrossJoinNudgesEligible ? await showJpdCrossJoinNudge({
                cloudId: cloudId,
                userId: userId,
                flags: flags,
                createAnalyticsEvent: createAnalyticsEvent,
                push: push
            }) : await triggerJiraCrossJoinNudge({
                cloudId: cloudId,
                userId: userId,
                flags: flags,
                createAnalyticsEvent: createAnalyticsEvent,
                push: push
            });
        })();
    }, [
        cloudId,
        createAnalyticsEvent,
        flags,
        push,
        userId
    ]);
    const onClick = (0, $Asv1P.useCallbackWithAnalytics)(()=>{
        setIsOpen(!isOpen);
    }, {
        type: 'sendUIEvent',
        data: {
            source: 'globalNavigation',
            action: 'clicked',
            actionSubject: 'navigationItem',
            actionSubjectId: 'appSwitcher',
            attributes: {
                selectedItemPageContext: routeDataRef.current?.routeName,
                navigationLayer: 'global',
                navVersion: '3',
                navdexPointType: (0, $dEBDF.START_TOUCH)
            }
        }
    });
    const onClose = ()=>{
        setIsOpen(false);
    };
    return !isLicensed ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $f1YjX.default), {
        cloudId: cloudId,
        product: $87f5aa0f5bf06dd6$var$CONFLUENCE_PRODUCT
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        placement: "bottom-start",
        rootBoundary: "document",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($87f5aa0f5bf06dd6$var$SwitcherContentLoadable, {
                cloudId: cloudId,
                onClose: onClose
            }),
        isOpen: isOpen,
        onClose: onClose,
        shouldRenderToParent: true,
        trigger: (triggerProps)=>{
            const appSwitcherTrigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $akh1w.AppSwitcherNudgeToolTip), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iZfSS.AppSwitcher), {
                onClick: onClick,
                tooltip: // WARN: not importing the message from @atlassian/switcher
                // because single message from this package pulls more than 100 kB
                // of i18n JS into page loading critical path.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $87f5aa0f5bf06dd6$var$i18n.appSwitcherTooltip),
                isSelected: isOpen,
                label: formatMessage($87f5aa0f5bf06dd6$var$i18n.appSwitcherLabel),
                ...triggerProps
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
                "data-testid": "app-navigation-app-switcher"
            }, isJswXflowUserQSEligible && (0, $9wGTI.fg)('cc_onboarding_experience') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
                name: "app-switcher-spotlight"
            }, appSwitcherTrigger) : appSwitcherTrigger);
        }
    }));
};
const $87f5aa0f5bf06dd6$export$6325b69f8dd8cc5d = (0, $7aRa9.withFlags)($87f5aa0f5bf06dd6$export$582f757cbaeaf9c0);

});
parcelRegister("iZfSS", function(module, exports) {

$parcel$export(module.exports, "AppSwitcher", () => $9e0b75e670ff7392$export$9923361bd43fa030);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $kNHXO = parcelRequire("kNHXO");

var $9RjLU = parcelRequire("9RjLU");

var $8MTIk = parcelRequire("8MTIk");
const $9e0b75e670ff7392$export$9923361bd43fa030 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8MTIk.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9RjLU))), {
            color: "currentColor",
            spacing: "spacious",
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps'
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});
const $9e0b75e670ff7392$export$28833e0dfbd2ac80 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8MTIk.IconButton), {
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kNHXO))), {
            label: typeof tooltip === 'string' ? tooltip : 'Switch apps',
            color: "var(--ds-icon, #44546F)"
        }),
        component: component,
        href: href,
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        ...rest
    });
});
var // exists only to extract props
// eslint-disable-next-line import/no-anonymous-default-export
$9e0b75e670ff7392$export$2e2bcd8739ae039 = (props)=>{};

});
parcelRegister("9RjLU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9a6526ba72ad9bbb4f9b91ad0dbd2f69>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72d8668a8c12645f$var$_react = $72d8668a8c12645f$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $72d8668a8c12645f$var$_appSwitcher = $72d8668a8c12645f$var$_interopRequireDefault((parcelRequire("kNHXO")));

var $72d8668a8c12645f$var$_appSwitcher2 = $72d8668a8c12645f$var$_interopRequireDefault((parcelRequire("cCp8H")));
function $72d8668a8c12645f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AppSwitcherIcon.
 * This component is AppSwitcherIcon, with `UNSAFE_fallbackIcon` set to "AppSwitcherIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for app switcher in global product navigation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $72d8668a8c12645f$var$AppSwitcherIcon = (props)=>/*#__PURE__*/ $72d8668a8c12645f$var$_react.default.createElement($72d8668a8c12645f$var$_appSwitcher.default, Object.assign({
        LEGACY_fallbackIcon: $72d8668a8c12645f$var$_appSwitcher2.default
    }, props));
$72d8668a8c12645f$var$AppSwitcherIcon.Name = 'AppSwitcherIconMigration';
var $72d8668a8c12645f$var$_default = module.exports.default = $72d8668a8c12645f$var$AppSwitcherIcon;

});


parcelRegister("f1YjX", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc8696e3d2c183fd$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $eEhUN = parcelRequire("eEhUN");

var $cUwlE = parcelRequire("cUwlE");

var $gyt00 = parcelRequire("gyt00");

var $a3xa0 = parcelRequire("a3xa0");

var $03bmy = parcelRequire("03bmy");
const $fc8696e3d2c183fd$var$THROTTLE_EXPIRES = 60000; // 60 seconds
const $fc8696e3d2c183fd$var$THROTTLE_OPTIONS = {
    leading: true,
    trailing: false
};
const $fc8696e3d2c183fd$var$TRIGGER_CONTEXT = {
    componentName: (0, $a3xa0.TRIGGER_COMPONENT),
    ...(0, $03bmy.default)
};
class $fc8696e3d2c183fd$var$PrefetchTrigger extends (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Component {
    render() {
        const { children: children, Container: Container = 'div' } = this.props;
        return /*#__PURE__*/ (0, $7UHDa.jsx)(Container, {
            onFocus: this.handleMouseEnter,
            onMouseEnter: this.handleMouseEnter,
            onClick: this.handleMouseClick,
            children: children
        });
    }
    constructor(...args){
        super(...args);
        this.lastEnteredAt = void 0;
        this.fireOperationalEvent = (payload)=>{
            if (this.props.createAnalyticsEvent) this.props.createAnalyticsEvent({
                eventType: (0, $a3xa0.OPERATIONAL_EVENT_TYPE),
                actionSubject: (0, $a3xa0.TRIGGER_SUBJECT),
                ...payload
            }).fire((0, $a3xa0.NAVIGATION_CHANNEL));
        };
        this.triggerPrefetch = (0, (/*@__PURE__*/$parcel$interopDefault($eEhUN)))(()=>{
            (0, $cUwlE.prefetch)(this.props);
            this.fireOperationalEvent({
                action: 'triggered'
            });
        }, $fc8696e3d2c183fd$var$THROTTLE_EXPIRES, $fc8696e3d2c183fd$var$THROTTLE_OPTIONS);
        this.handleMouseEnter = ()=>{
            this.triggerPrefetch();
            this.lastEnteredAt = (0, $gyt00.performanceNow)();
        };
        this.handleMouseClick = ()=>{
            if (this.lastEnteredAt) {
                const hoverToClick = Math.round((0, $gyt00.performanceNow)() - this.lastEnteredAt);
                this.fireOperationalEvent({
                    action: 'clicked',
                    attributes: {
                        hoverToClick: hoverToClick
                    }
                });
            }
        };
    }
}
const $fc8696e3d2c183fd$var$PrefetchTriggerWithEvents = (0, $a3xa0.withAnalyticsEvents)()($fc8696e3d2c183fd$var$PrefetchTrigger);
var $fc8696e3d2c183fd$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $a3xa0.NavigationAnalyticsContext), {
        data: $fc8696e3d2c183fd$var$TRIGGER_CONTEXT,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($fc8696e3d2c183fd$var$PrefetchTriggerWithEvents, {
            ...props
        })
    });

});
parcelRegister("cUwlE", function(module, exports) {

$parcel$export(module.exports, "prefetch", () => $4d0cc6fe2704cf10$export$f003ab04b0b3c00e);

var $lICpR = parcelRequire("lICpR");

var $cA3Tq = parcelRequire("cA3Tq");

var $l2qS4 = parcelRequire("l2qS4");

var $cDgbr = parcelRequire("cDgbr");
const $4d0cc6fe2704cf10$export$f003ab04b0b3c00e = (props)=>{
    const { cloudId: cloudId, product: product } = props;
    (0, $cDgbr.default)(product);
    (0, $cA3Tq.prefetchAvailableProducts)({
        cloudId: cloudId,
        product: product
    });
    (0, $l2qS4.prefetchJoinableSites)(props.joinableSitesDataProvider);
    if (cloudId) (0, $lICpR.prefetchAll)({
        cloudId: cloudId
    });
};

});
parcelRegister("cDgbr", function(module, exports) {

$parcel$export(module.exports, "default", () => $58c26cbd87218cf2$export$2e2bcd8739ae039);

var $dcO0p = parcelRequire("dcO0p");

var $2uNd6 = parcelRequire("2uNd6");
var $58c26cbd87218cf2$export$2e2bcd8739ae039 = (product)=>{
    (0, $2uNd6.loadAtlassianSwitcher)();
    if (product === (0, $dcO0p.Product).JIRA) return (0, $2uNd6.loadJiraSwitcher)();
    if (product === (0, $dcO0p.Product).CONFLUENCE) return (0, $2uNd6.loadConfluenceSwitcher)();
    return (0, $2uNd6.loadGenericSwitcher)();
};

});



parcelRegister("akh1w", function(module, exports) {

$parcel$export(module.exports, "AppSwitcherNudgeToolTip", () => $56fef2b484b7e7ea$export$c9637de5a973a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $axAnW = parcelRequire("axAnW");

var $gR84W = parcelRequire("gR84W");

var $1lhEF = parcelRequire("1lhEF");

var $dcJ7R = parcelRequire("dcJ7R");
var $ecnYn = parcelRequire("ecnYn");

var $inPa6 = parcelRequire("inPa6");

var $67Foi = parcelRequire("67Foi");

var $bQm3c = parcelRequire("bQm3c");

var $lwNi3 = parcelRequire("lwNi3");

var $9oxdN = parcelRequire("9oxdN");

var $dIouf = parcelRequire("dIouf");

var $fqxbx = parcelRequire("fqxbx");
var $hUCYs = parcelRequire("hUCYs");
const $56fef2b484b7e7ea$var$i18n = (0, $2nPZH.defineMessages)({
    heading: {
        defaultMessage: "New product added",
        id: "app-navigation.app-switcher-nudge-tooltip.heading"
    },
    jsmContent: {
        defaultMessage: "Someone in your team has just started using Jira Service Management. It\u2019s been added to your site for free.",
        id: "app-navigation.app-switcher-nudge-tooltip.jsm-content"
    },
    jpdContent: {
        defaultMessage: "Someone in your team has just started using Jira Product Discovery. It\u2019s been added to your site for free.",
        id: "app-navigation.app-switcher-nudge-tooltip.jpd-content"
    },
    jsmPrimaryButtonText: {
        defaultMessage: "Take a tour",
        id: "app-navigation.app-switcher-nudge-tooltip.jsm-primary-button-text"
    },
    jpdPrimaryButtonText: {
        defaultMessage: "Show details",
        id: "app-navigation.app-switcher-nudge-tooltip.jpd-primary-button-text"
    },
    secondaryAction: {
        defaultMessage: "Dismiss",
        id: "app-navigation.app-switcher-nudge-tooltip.secondary-action"
    }
});
const $56fef2b484b7e7ea$export$83c8d7110915321e = 'endUserActivateSpotlightScreen';
const $56fef2b484b7e7ea$var$StyledNudge = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...restProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56fef2b484b7e7ea$var$NudgeWrapper, {
        ...restProps,
        ref: ref,
        "data-testid": nudgeTestId
    }, children));
const $56fef2b484b7e7ea$export$5871aa9763d9526b = [
    {
        messageId: 'confluence-end-user-activated-jsm_v2',
        heading: $56fef2b484b7e7ea$var$i18n.heading,
        content: $56fef2b484b7e7ea$var$i18n.jsmContent,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($hUCYs))),
        primaryActionText: $56fef2b484b7e7ea$var$i18n.jsmPrimaryButtonText,
        primaryOnClickAction: ()=>window.open('/secure/WelcomeToSD.jspa?decorator=jsd-onboarding', '_blank')
    },
    {
        messageId: 'confluence-end-user-activated-jpd_v2',
        heading: $56fef2b484b7e7ea$var$i18n.heading,
        content: $56fef2b484b7e7ea$var$i18n.jpdContent,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($fqxbx))),
        primaryActionText: $56fef2b484b7e7ea$var$i18n.jpdPrimaryButtonText,
        primaryOnClickAction: (environment, orgId, cloudId)=>{
            window.open(`https://${environment === 'PRODUCTION' ? 'admin.atlassian.com' : 'admin.stg.atlassian.com'}/o/${orgId}/products/jira-product-discovery/${cloudId}`, '_blank');
        }
    }
];
const $56fef2b484b7e7ea$var$AppSwitcherNudge = ({ nudge: nudge, fallback: fallback, children: children })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { environment: environment, cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const [dismissed, setDismissed] = (0, $gwFzn.useState)(false);
    const coordinationClient = (0, $lwNi3.useCoordinationClient)();
    const { messageId: messageId } = nudge; // we have turned off the duplicate check for our messageIds in EP so that the nudge border will be shown repeatedly until
    // the user sees the spotlight. We then use the feature-delivery API to mark the user as having seen it, and stop showing
    // it again (even though the user will remain enrolled in the audience for it)
    const [persistedShowFeature, stopFeature] = (0, $9oxdN.useFeatureDiscovery)(`${messageId}.seen`); // persistedShowFeature becomes false once stopFeature() is called, however, we're using that to just mark the spotlight as seen
    // and we don't want to dismiss the spotlight straight away, so we keep to show it
    const [showFeature, setShowFeature] = (0, $gwFzn.useState)(persistedShowFeature);
    (0, $gwFzn.useEffect)(()=>{
        if (persistedShowFeature) setShowFeature(true);
    }, [
        persistedShowFeature
    ]);
    const hideMessage = (messageId)=>{
        setDismissed(true);
        coordinationClient.stop(messageId);
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'endUserActivateSpotlight',
                source: $56fef2b484b7e7ea$export$83c8d7110915321e,
                attributes: {
                    messageId: messageId
                }
            }
        }).fire();
    };
    const handleFireDismissButtonClickEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'endUserActivateSpotlightDismissButton',
                source: $56fef2b484b7e7ea$export$83c8d7110915321e,
                attributes: {
                    messageId: messageId
                }
            }
        }).fire();
    };
    const handleFireTourButtonClickEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'endUserActivateSpotlightTourButton',
                source: $56fef2b484b7e7ea$export$83c8d7110915321e,
                attributes: {
                    messageId: messageId
                }
            }
        }).fire();
    };
    const nudgeSpotlightRef = (0, $gwFzn.useRef)({}); // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    return showFeature && !isSSR ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $axAnW.default), {
        client: coordinationClient,
        messageId: messageId,
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67Foi.ScreenEvent), {
        attributes: {
            messageId: messageId
        },
        name: "endUserActivateSpotlightNudgeScreen",
        id: "endUserActivateSpotlightNudgeScreenEvent"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gR84W.NudgeSpotlight), {
        hidden: dismissed,
        setHidden: ()=>hideMessage(messageId),
        heading: formatMessage(nudge.heading),
        width: 276,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67Foi.ScreenEvent), {
            attributes: {
                messageId: messageId
            },
            name: $56fef2b484b7e7ea$export$83c8d7110915321e,
            id: `${$56fef2b484b7e7ea$export$83c8d7110915321e}-event`
        }), formatMessage(nudge.content)),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dcJ7R.default), {
            xcss: $56fef2b484b7e7ea$var$imgStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("img", {
            alt: "",
            src: nudge.image,
            width: 276
        })),
        actions: [
            {
                text: formatMessage(nudge.primaryActionText),
                onClick: ()=>{
                    handleFireTourButtonClickEvent();
                    nudge.primaryOnClickAction(environment, orgId, cloudId);
                }
            },
            {
                text: formatMessage($56fef2b484b7e7ea$var$i18n.secondaryAction),
                onClick: ()=>{
                    handleFireDismissButtonClickEvent();
                    hideMessage(messageId);
                }
            }
        ],
        position: "bottom-end",
        onOutsideClick: ()=>hideMessage(messageId),
        nudgeTestId: `${nudge.messageId}-nudge`,
        cardTestId: `${nudge.messageId}-card`,
        showSpotlightCardOnFirstRender: false,
        onShow: stopFeature,
        nudge: $56fef2b484b7e7ea$var$StyledNudge,
        ref: nudgeSpotlightRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1lhEF.Pulse), {
        testId: `${messageId}-nudge-pulsing-border`,
        radius: 50,
        pulse: !dismissed,
        onFocus: ()=>{
            !dismissed && nudgeSpotlightRef.current?.toggleCardVisibility?.(true);
        }
    }, children)))) : fallback;
};
const $56fef2b484b7e7ea$export$c9637de5a973a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.GenericErrorBoundary), {
        attribution: (0, $dIouf.Attribution).GROWTH_MULTIPLIERS,
        renderOnError: ()=>children
    }, $56fef2b484b7e7ea$export$5871aa9763d9526b.reduce((acc, nudge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($56fef2b484b7e7ea$var$AppSwitcherNudge, {
            nudge: nudge,
            fallback: acc
        }, children), children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $56fef2b484b7e7ea$var$NudgeWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_18s81nxw _1hbsidpf _1u71idpf _y2qtidpf _fl8bidpf _shbiidpf _b9uxidpf _15q3idpf _uoh1idpf _1689idpf _1s2fidpf _egytidpf _yl3tidpf _1cmlidpf _hzefidpf _1q5lidpf _97vyidpf _2ynaidpf _1uv9idpf _5gciidpf _17fyidpf",
            __cmplp.className
        ])
    });
});
const $56fef2b484b7e7ea$var$imgStyles = (0, $ecnYn.xcss)({
    height: '154px',
    width: '276px',
    marginBottom: 'space.negative.050'
});

});
parcelRegister("fqxbx", function(module, exports) {
module.exports = new URL("jpd-try-end-learn.5d9c30dc.svg", import.meta.url).toString();

});

parcelRegister("hUCYs", function(module, exports) {
module.exports = new URL("jsm-try-end-learn.c322b649.svg", import.meta.url).toString();

});


parcelRegister("h2zMU", function(module, exports) {

let $c67e624b6a8e3884$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c67e624b6a8e3884$var$load("bI3DO"),
    $c67e624b6a8e3884$var$load("jCNLy"),
    $c67e624b6a8e3884$var$load("5epKi"),
    $c67e624b6a8e3884$var$load("c6MKV"),
    $c67e624b6a8e3884$var$load("bx5Ka"),
    $c67e624b6a8e3884$var$load("dkU9O"),
    $c67e624b6a8e3884$var$load("ffEVr"),
    $c67e624b6a8e3884$var$load("joJy8"),
    $c67e624b6a8e3884$var$load("aHE9G"),
    $c67e624b6a8e3884$var$load("ciAVN"),
    $c67e624b6a8e3884$var$load("5GXmr")
]).then(()=>parcelRequire('eWL6H'));

});

parcelRegister("rIJcv", function(module, exports) {

let $053537ca08cac330$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $053537ca08cac330$var$load("8DoxJ"),
    $053537ca08cac330$var$load("ffEVr"),
    $053537ca08cac330$var$load("dTsOE"),
    $053537ca08cac330$var$load("joJy8"),
    $053537ca08cac330$var$load("aHE9G"),
    $053537ca08cac330$var$load("7GU1S")
]).then(()=>parcelRequire('9lSmU'));

});




//# sourceMappingURL=AppSwitcherComponentWrapper.ab42a690.js.map
